module.exports = __webpack_public_path__ + "img/ilustrasi-login.564d0e1e.svg";